import { useMutation, useQuery } from "react-query";
import { GET_ICON_DROPOWN, GET_REGION_DROPDOWN, GET_PROVINCE_DROPOWN, GET_PURPOSE_OF_VISIT_DROPOWN, GET_TEMPLE_DROPOWN, 
  GET_TEMPLE_GROUP_DROPOWN, GET_TRANSPORTATION_DROPOWN, GET_TYPE_OF_FEEDBACK_DROPOWN, GET_USER_DROPOWN, GET_ZONE_DROPOWN, 
  GET_USER_DELETE_REASON_DROPOWN, GET_NATIONALITY_DROPOWN } from "../../constants/queryKeys";
import { getIconDropDown, getProvinceDropDown, getPurposeOfVisitDropDown, getRegionDropDown, getTempleDropDown, 
  getTempleGroupDropDown, getTransportationDown, getTypeOfFeedbackDown, getUserDropDown, getZoneDropDown, 
  getUserDeleteReasonDropDown, editOrdering, getNationalityDropDown } from "../apiClient/dropDown";

export const useGetUserDropDown = ({ payload, config }) => {
  return useQuery([GET_USER_DROPOWN, payload], () => getUserDropDown(payload), config);
};
export const useGetIconDropDown = ({ payload, config }) => {
  return useQuery([GET_ICON_DROPOWN, payload], () => getIconDropDown(payload), config);
};
export const useGetRegionDropDown = ({ payload, config }) => {
  return useQuery([GET_REGION_DROPDOWN, payload], () => getRegionDropDown(payload), config);
};
export const useGetTempleDropDown = ({ payload, config }) => {
  return useQuery([GET_TEMPLE_DROPOWN, payload], () => getTempleDropDown(payload), config);
};
export const useGetTempleGroupDropDown = ({ payload, config }) => {
  return useQuery([GET_TEMPLE_GROUP_DROPOWN, payload], () => getTempleGroupDropDown(payload), config);
};
export const useGetZoneDropDown = ({ payload, config }) => {
  return useQuery([GET_ZONE_DROPOWN, payload], () => getZoneDropDown(payload), config);
};
export const useGetNationality = ({ payload, config }) => {
  return useQuery([GET_NATIONALITY_DROPOWN, payload], () => getNationalityDropDown(payload), config);
};
export const useGetProvinceDropDown = ({ payload, config }) => {
  return useQuery([GET_PROVINCE_DROPOWN, payload], () => getProvinceDropDown(payload), config);
};
export const useGetPurposeOfVisitDropDown = ({ payload, config }) => {
  return useQuery([GET_PURPOSE_OF_VISIT_DROPOWN, payload], () => getPurposeOfVisitDropDown(payload), config);
};
export const useGetTransportationDropDown = ({ payload, config }) => {
  return useQuery([GET_TRANSPORTATION_DROPOWN, payload], () => getTransportationDown(payload), config);
};
export const useGetTypeOfFeedbackDropDown = ({ payload, config }) => {
  return useQuery([GET_TYPE_OF_FEEDBACK_DROPOWN, payload], () => getTypeOfFeedbackDown(payload), config);
};
export const useGetUserDeleteReasonDropDown = ({ payload, config }) => {
  return useQuery([GET_USER_DELETE_REASON_DROPOWN, payload], () => getUserDeleteReasonDropDown(payload), config);
};
export const useEditOrderingMutation = (options) => {
  return useMutation((payload) => editOrdering(payload), options);
};
